import { SecureClient } from '../../../utils';

const getNachStatusAPICall = ({
  customerCredentials,
  payload,
  successFn,
  errorFn,
  finallyFn,
}) => {
  const { customerId, Authorization, customerRefNum } = customerCredentials;
  SecureClient({
    isEncrypted: true,
    customerId,
    route: 'customerkyc/getnachstatus',
    payload,
    otherPayloadDetailsPresent: true,
    headers: { Authorization },
    method: 'POST',
    successFn,
    errorFn,
    finallyFn,
  });
};

export default getNachStatusAPICall;
